import { createSlice } from '@reduxjs/toolkit';

import { Affiliation } from '@/types/affiliation';
import * as asyncActions from './asyncActions';

type State = {
  items: Affiliation[];
};

const initialState: State = {
  items: [],
};

const slice = createSlice({
  name: 'organization-affiliation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(asyncActions.fetchAll.fulfilled, (state, action) => {
      state.items = action.payload;
    });
  },
});

export const actions = slice.actions;
export default slice.reducer;
